import { Controller } from "@hotwired/stimulus"

// Keeps the mobile reply form anchored above the virtual keyboard on iOS.
//
// iOS Safari does not reliably fire visualViewport resize/scroll events in
// all versions. Instead of depending on those events alone, we start a
// polling loop when an input inside the form receives focus. The loop reads
// visualViewport dimensions every 100 ms and repositions the form with
// position:fixed + dynamic bottom offset. Polling stops on focusout.
const KEYBOARD_THRESHOLD_PX = 50
const POLL_INTERVAL_MS = 100

export default class extends Controller {
  connect() {
    this.heroButton = document.getElementById('responder-desde-el-hero')
    if (this.heroButton) this.heroButton.disabled = true

    this.onFocusIn = this.handleFocusIn.bind(this)
    this.onFocusOut = this.handleFocusOut.bind(this)
    this.element.addEventListener('focusin', this.onFocusIn)
    this.element.addEventListener('focusout', this.onFocusOut)
  }

  disconnect() {
    if (this.heroButton) this.heroButton.disabled = false

    this.element.removeEventListener('focusin', this.onFocusIn)
    this.element.removeEventListener('focusout', this.onFocusOut)
    this.stopPolling()
    this.resetPosition()
  }

  handleFocusIn() {
    this.startPolling()
  }

  handleFocusOut() {
    // Short delay: focus may move between elements inside the form (e.g.
    // textarea → toolbar button). Only stop when focus leaves the form.
    setTimeout(() => {
      if (!this.element.contains(document.activeElement)) {
        this.stopPolling()
        this.resetPosition()
      }
    }, 150)
  }

  startPolling() {
    if (this.pollId) return
    this.adjustPosition()
    this.pollId = setInterval(() => this.adjustPosition(), POLL_INTERVAL_MS)
  }

  stopPolling() {
    if (this.pollId) {
      clearInterval(this.pollId)
      this.pollId = null
    }
  }

  adjustPosition() {
    const viewport = window.visualViewport
    if (!viewport) return

    const keyboardHeight = window.innerHeight - viewport.height - viewport.offsetTop

    if (keyboardHeight > KEYBOARD_THRESHOLD_PX) {
      this.element.classList.add('keyboard-open')
      const formHeight = this.element.offsetHeight
      const top = viewport.offsetTop + viewport.height - formHeight
      this.element.style.top = `${top}px`
      this.element.style.bottom = 'auto'
    } else {
      this.resetPosition()
    }
  }

  resetPosition() {
    this.element.classList.remove('keyboard-open')
    this.element.style.top = ''
    this.element.style.bottom = ''
  }
}
